import { render, staticRenderFns } from "./runWorkoutSummary.vue?vue&type=template&id=51872c48&scoped=true"
import script from "./runWorkoutSummary.vue?vue&type=script&lang=js"
export * from "./runWorkoutSummary.vue?vue&type=script&lang=js"
import style0 from "./runWorkoutSummary.vue?vue&type=style&index=0&id=51872c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51872c48",
  null
  
)

export default component.exports